import React from "react";
import HeaderLeft from "./HeaderLeft";

import imagespdf from "../assets/images/pdf.png";
import { Link, useNavigate } from "react-router-dom";
import DropdownRight from "./DropdownRight";
import { useSelector } from "react-redux";

function AreYouSure(props) {
  const counter = useSelector((state) => state.cve.cv);

  const navigate = useNavigate();

  const BackPage = () => {
    navigate(-1);
  };

  return (
    <>
      <header>
        <div class="custom_container ">
          <HeaderLeft />
          <div class="user_profile">
            <DropdownRight />
          </div>
        </div>
      </header>
      <section class="otp_verification custom_hight">
        <div class="login_inner">
          <h1 class="mb_30 main_title ">Are you sure?</h1>
          <p class="mb_40 them_para text-center mx-auto text_limit">
            Are you sure you want to upload resume to your profile? This action
            can be undone in settings.
          </p>
          <div class="uplode_file_show">
            <object
              width="100%"
              height="250"
              data={counter}
              type="image/gif"
            ></object>
          </div>
          <p class="text-show-file">resume.pdf</p>
          <div class="btn_wraper">
            <button
              type="button"
              class="them_btn mt_40 mb_30"
              onClick={BackPage}
            >
              No, Select other
            </button>
            <Link to="/downloadSample">
              <button type="button" class="them_btn_ouline mt_40 mb_30 ml-2">
                Yes, Continue
              </button>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default AreYouSure;
